import { createAction } from '@reduxjs/toolkit';
import { api, handleApiErrors } from 'lib/src/utils/api';
import { AppDispatch } from 'src/redux/store';

export const deleteTagRequest = createAction('deleteTagRequest');
export const deleteTagSuccess = createAction<number>('deleteTagSuccess');
export const deleteTagFailure = createAction('deleteTagFailure');

export const deleteTag = (id: number) => async (dispatch: AppDispatch): Promise<void> => {
    dispatch(deleteTagRequest());
    try {
        await api.delete(`admin/challengeTags/${id}`);

        dispatch(deleteTagSuccess(id));
    } catch (e: any) {
        handleApiErrors(dispatch, deleteTagFailure, e);
    }
};
